// extracted by mini-css-extract-plugin
export default {"link":"QC-z","disabled":"RC-z"};